import { snapshot } from 'valtio'
import { type SingleValue } from 'react-select'
import lodashCloneDeep from 'lodash/cloneDeep'
import { type GlobalCustomerCardType } from '../../../../../shared/types/GlobalCustomerCardType'
import {
  type GlobalReactSelectOptionStringValueType
} from '../../../../../shared/types/GlobalReactSelectOptionStringValueType'

import { creditCardListProxy } from '../../../../../shared/proxies/creditCardListProxy'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'
import { RecurringPaymentNewProxyFormFieldNamesEnum } from '../recurringPaymentNewProxyFormFieldNamesEnum'
import { addToArray, removeFromArray } from '../../../../../shared/utils/arrayUtils'
import {
  cardAddProxy
} from '../../../../../shared/components/CardAddSlideOver/cardAddProxy'
import { CardAddFormFieldNamesEnum } from '../../../../../shared/components/CardAddSlideOver/cardAddFormFieldNamesEnum'
import {
  executeCustomerCardsSearchForRecurringConfiguration
} from './executeCustomerCardsSearchForRecurringConfiguration'

export function buildCreditCardOption (customerCard: GlobalCustomerCardType): GlobalReactSelectOptionStringValueType {
  return {
    label: customerCard.cardName ? `${customerCard.isPrimary ? 'PRIMARY: ' : ''} ${customerCard.cardName}` : '',
    value: customerCard.id
  }
}
export function buildCreditCardOptions (customerCards: readonly GlobalCustomerCardType[]): GlobalReactSelectOptionStringValueType[] {
  return customerCards.map(buildCreditCardOption)
}

export async function loadCreditCardOptions (): Promise<void> {
  await executeCustomerCardsSearchForRecurringConfiguration()

  const { customerCards } = snapshot(creditCardListProxy)
  creditCardListProxy.formattedCards = buildCreditCardOptions(customerCards)
}

export async function handleCreditCardChange (newValue: SingleValue<GlobalReactSelectOptionStringValueType>): Promise<void> {
  const customerCardId = newValue?.value ?? null
  const { customerCards } = snapshot(creditCardListProxy)
  const creditCard = customerCards.find(c => c.id === customerCardId)

  if (creditCard) {
    recurringPaymentNewProxy.customerCard = lodashCloneDeep(creditCard)
    recurringPaymentNewProxy.form.dirty = addToArray(recurringPaymentNewProxy.form.dirty, RecurringPaymentNewProxyFormFieldNamesEnum.CustomerCard)

    //remove ach when a card is selected as a failsafe...bc
    recurringPaymentNewProxy.achAccount = null
    recurringPaymentNewProxy.form.dirty = removeFromArray(recurringPaymentNewProxy.form.dirty, RecurringPaymentNewProxyFormFieldNamesEnum.AchAccount)
  } else {
    recurringPaymentNewProxy.customerCard = null
    recurringPaymentNewProxy.form.dirty = removeFromArray(recurringPaymentNewProxy.form.dirty, RecurringPaymentNewProxyFormFieldNamesEnum.CustomerCard)
  }
}

export function populateCardInformationFromCustomer (): void {
  const customer = recurringPaymentNewProxy.customer

  if (customer) {
    cardAddProxy.formValues.firstName = customer.firstName
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.FirstName)

    cardAddProxy.formValues.lastName = customer.lastName
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.LastName)

    cardAddProxy.formValues.streetAddressOne = customer.addressOne
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.StreetAddressOne)

    if (customer.addressTwo) {
      cardAddProxy.formValues.streetAddressTwo = customer.addressTwo
      cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.StreetAddressTwo)
    }

    cardAddProxy.formValues.city = customer.city
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.City)

    cardAddProxy.formValues.state = customer.state
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.State)

    cardAddProxy.formValues.postalCode = customer.postalCode
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.PostalCode)

    cardAddProxy.formValues.countryCode = customer.countryCode
    cardAddProxy.formDirty = addToArray(cardAddProxy.formDirty, CardAddFormFieldNamesEnum.CountryCode)
  }
}
